import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from "/seu-frontend/layouts/MainLayout";

Vue.use(VueRouter)

const routes = ({store, i18n}) => {
  const initData = async (to, from, next) => {
    store.dispatch('init'); //check if we can run dispatch init without waiting for promise
    const lang =  to.params.lang ? to.params.lang.toUpperCase():store.state.defaultLanguage
    store.commit('setCurrentLanguage',lang)
    i18n.locale = lang.toLowerCase()
    return next()
  };


  return [
    {
      path: '/',
      redirect: () => {
        const paramLang = store.state.currentLanguage!==store.state.defaultLanguage ? store.state.currentLanguage.toLowerCase():null;
        return paramLang ? {
          name: 'IndexPage',
          params: {
            lang: paramLang,
            slug: 'seu'
          }
        }:{
          name: 'IndexPage',
          params: {
            slug: 'seu'
          }
        }
      }
    },
    {
      path: '/:lang(en|de)?',
      beforeEnter: initData,
      component: MainLayout,
      children: [
        {
          path: '',
          name: 'IndexPage',
          component: () => import('../pages/IndexPage')
        },
        {
          path: ':slug(challenges)',
          name: 'ChallengesPage',
          component: () => import('../pages/ChallengesPage')
        },
        {
          path: ':slug(strategie|strategy)',
          name: 'StrategyPage',
          component: () => import('../pages/StrategyPage')
        },
        {
          path: ':slug(angebot|services)',
          name: 'OfferPage',
          component: () => import('../pages/OfferPage')
        },
        {
          path: ':slug(engineering)',
          name: 'FieldsPage',
          component: () => import('../pages/FieldsPage')
        },
        {
          path: ':slug(wir|about)',
          name: 'AboutUsPage',
          component: () => import('../pages/AboutUsPage')
        },
        {
          path: ':slug(kontakt|contact)',
          name: 'ContactUsPage',
          component: () => import('../pages/ContactPage')
        },
        {
          path: 'blog',
          name: 'PostsPage',
          component: () => import('../pages/blog/PostsPage.vue'),
        },
        {
          path: 'blog/category/:categorySlug',
          name: 'CategoryPostsPage',
          props:true,
          component: () => import('../pages/blog/PostsPage.vue'),
        },
        {
          path: 'blog/:slug',
          name: 'PostDetailsPage',
          props: true,
          component: () => import('../pages/blog/PostDetailsPage.vue')
        },
      ],

    },

  ]
}

const getRouter = ({store, i18n}) => {
  return new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes({store, i18n}),
    scrollBehavior(to, from, savedPosition) {
      // always scroll to top

      if (to.path===from.path && !to.hash) {
        return savedPosition;
      } else if (to.hash) {
        this.app.$scrollTo(to.hash);
        return {selector: to.hash}
      } else {
        return {x: 0, y: 0}
      }
    },
  });
}

export {getRouter}
